(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/javascripts/utils/cancel-wager.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/javascripts/utils/cancel-wager.js');

'use strict';

const formatCurrency = svs.utils.format.Currency;
function confirmDialog() {
  return new Promise(resolve => {
    const dialogMessages = [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Vill du annullera spelet?',
      align: svs.ui.dialog.message.align.CENTER
    }];
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      title: 'Annullera',
      message: [...dialogMessages],
      actions: [{
        title: 'Avbryt',
        callback() {
          dialog.close();
          resolve(false);
        }
      }, {
        title: 'Annullera',
        callback() {
          dialog.close();
          resolve(true);
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  });
}
function successDialog(wager) {
  return new Promise(resolve => {
    const betAmount = wager.betAmount;
    svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      title: 'Spel annullerat',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: "Ditt spel f\xF6r ".concat(formatCurrency(betAmount), " kr har annullerats.")
      }],
      actions: [{
        title: 'Okej',
        callback(e, forms, dialog) {
          dialog.close();
          resolve();
        }
      }]
    }));
  });
}
async function cancelWager(_ref) {
  let wager = _ref.wager;
  const confirmed = await confirmDialog();
  if (confirmed) {
    try {
      await svs.tur.apiCaller.drawgames.deleteWager({
        wagerId: wager.wagerId
      });
      await successDialog(wager);
      svs.utils.url.navigate(svs.core.urlMapping.get('myBetsHome'));
    } catch (error) {
      svs.lyckoplatsen.logger.warn('Failed to cancel wager', error);
      if (error.code === '8 105') {
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          type: svs.ui.dialog.type.DEFAULT,
          icon: 'time-limit',
          title: 'Annullering inte möjlig',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: 'Du kan annullera ett spel upp till 5 minuter efter spelstopp. Den tiden har tyvärr passerat.'
          }],
          actions: [{
            title: 'Okej'
          }]
        }));
      } else {
        svs.tur.apierrors.showErrorMessage({
          response: error.code
        });
      }
    }
  }
}
Object.assign(svs.lyckoplatsen.utils, {
  cancelWager
});

 })(window);